/* eslint-disable react/prop-types */
import React from 'react';
import classNames from 'classnames';

import clickoutScript from '../../utils/clickoutScript';
import { ReactComponent as LinkIcon } from '../../images/icons/link.svg';

import styles from './ShopDetailsPage.module.scss';
import ReviewStats from '../../components/ReviewStats/ReviewStats';

const SDPHeader = ({ shopInfo, clickout, profile, setOpenOverlay, form }) => {
  // const scrollToForm = useCallback(() => {
  //   if (profile && form.current) {
  //     window.scrollTo({ behavior: 'smooth', left: 0, top: form.current.offsetTop - 100 });
  //   }
  // }, [profile, form]);

  // const scrollToReviews = () => {
  //   const item = document.querySelector('#ShopReviewsSection');
  //   item.scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'nearest' });
  // };

  return (
    <header className={classNames(styles.shopInfo)}>
      {/* <div className={styles.shopButtonContainer}>
        <Button classList={{ root: styles.shopButton }} variation="secondary">
          <a
            onClick={() => clickoutScript(shopInfo.shop_link, clickout, false)}
            href={clickoutScript(shopInfo.shop_link, clickout, true)}
            rel="noopener noreferrer"
            target="_blank"
            data-testid="ShopDetailsPageShopLink"
          >
            <FormattedMessage id="shop.goTo" defaultMessage="Shop at this shop" /> {shopInfo.shop_name}
          </a>
        </Button>
      </div> */}
      <div className={styles.title}>
        {/* <div className={styles.logoContainer}>
          <img
            src={shopInfo.shop_logo_233_100}
            alt={`${shopInfo.shop_name}'s logo`}
            title={`${shopInfo.shop_name}'s logo`}
            height={45}
          />
        </div> */}
        <h1>{shopInfo.shop_name}</h1>
      </div>
      <div className={styles.siteLink}>
        <a
          onClick={() => clickoutScript(shopInfo.shop_link, clickout, false)}
          href={clickoutScript(shopInfo.shop_link, clickout, true)}
          target="_blank"
          rel="noopener noreferrer"
        >
          <LinkIcon /> {shopInfo.shop_website}
        </a>
      </div>
      {/* <div className={styles.shopReviewTotal}>
        <Rating value={!!shopInfo?.comments?.length ? shopInfo.ratings?.rating : 0} />
        {/* //todo: enable this button when rating will actually come from them.
        For now ratings values come from external sources
        {!!shopInfo.ratings.votes && (
          <button className={styles.shopReviewTotalLink} onClick={scrollToReviews}>
            {shopInfo.ratings.votes} <FormattedMessage id="shop.reviews" defaultMessage="Shop reviews" />
          </button>
        )}
        {!shopInfo.ratings.votes && (
          <p className={styles.firstReview} onClick={profile ? scrollToForm : () => setOpenOverlay(true)}>
            <FormattedMessage id="shop.writeFirstReview" defaultMessage="Write first review" />
          </p>
        )} */}
      {/* <span className={styles.shopReviewsCount}>
          <ReviewIcon /> {shopInfo?.comments?.length || 0}
        </span>
      </div>  */}
      <ReviewStats
        classList={{ rootComplementary: styles.shopReviewTotal }}
        ratingValue={!!shopInfo?.comments?.length ? shopInfo.ratings?.rating : 0}
        reviewsCount={shopInfo?.comments?.length}
      />
    </header>
  );
};
export default SDPHeader;
